import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Terms from "./views/Terms"
import TermsText from "@/views/TermsText"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/privacypolicy',
      name: 'termsText',
      component: TermsText
    }
  ]
})
